import React from 'react';
import { Link } from 'react-router-dom';

export default function Free() {
  return (
    <div className="page">
      <div className="card" style={{ maxWidth: '900px', margin: '0 auto' }}>
        <h1 style={{ marginBottom: '0.5rem' }}>Free Tier</h1>
        <p style={{ color: 'var(--color-text-light)', marginBottom: '1rem' }}>
          5 questions for 3 days. Pagination stops at question 5.
        </p>

        <ul style={{ lineHeight: 1.9, paddingLeft: '1.2rem', listStyle: 'disc' }}>
          <li>Pagination: 1 to 5 questions</li>
          <li>AI-generated questions with examples</li>
          <li>Answer in a text area</li>
          <li>Buttons: Save Page, Print Page</li>
          <li>No bonus</li>
        </ul>

        <div style={{ marginTop: '1.2rem', display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
          <Link to="/register" className="btn btn-primary">Start Free</Link>
          <Link to="/dashboard" className="btn btn-secondary">Open Free Question Page</Link>
        </div>
      </div>
    </div>
  );
}
